/**
 * Contact Type Enum
 * Represents the predefined contact types that must be unique per organization
 */
export enum ContactType {
    FirstEmergency = 'first_emergency_contact',
    SecondEmergency = 'second_emergency_contact',
    Financial = 'financial_contact',
    Security = 'security_contact',
    Support = 'support_contact',
    Technical = 'technical_contact'
}

/**
 * Contact Model (Read-only)
 * Represents a contact entity as received from the API
 */
export interface Contact {
    id: number;
    organizationId: number;
    uuid: string;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    contactType: ContactType;
    createdAt: string;
    updatedAt: string;
}

/**
 * SaveContact Model (Mutable)
 * Used for creating or updating a contact
 */
export interface SaveContact {
    uuid?: string;
    organizationId: number;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    contactType: ContactType;
}

/**
 * Helper function to get display name for contact type
 */
export const getContactTypeDisplayName = (type: ContactType): string => {
    const displayNames: Record<ContactType, string> = {
        [ContactType.FirstEmergency]: 'First Emergency Contact',
        [ContactType.SecondEmergency]: 'Second Emergency Contact',
        [ContactType.Financial]: 'Financial Contact',
        [ContactType.Security]: 'Security Contact',
        [ContactType.Support]: 'Support Contact',
        [ContactType.Technical]: 'Technical Contact'
    };
    return displayNames[type];
};

/**
 * Get all available contact types
 */
export const getAllContactTypes = (): ContactType[] => {
    return Object.values(ContactType);
};
